import { useEffect, useState } from 'react';
import { getExtensionUnits } from '../../services/extensionUnit/listExtensionUnitService.js';

export const useExtensionUnitsList = () => {
    const [extensionUnits, setExtensionUnits] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [error, setError] = useState('');
    // ordenamiento
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');

    useEffect(() => {
        loadExtensionUnits();
    }, []);

    const loadExtensionUnits = async () => {
        const data = await getExtensionUnits();
        data.sort((a, b) => a.name.localeCompare(b.name));
        setExtensionUnits(data);
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';

        setSortField(field);
        setSortOrder(order);

        setExtensionUnits(prev =>
            [...prev].sort((a, b) => {
                const aValue = field.split('.').reduce((o, i) => o?.[i], a);
                const bValue = field.split('.').reduce((o, i) => o?.[i], b);

                if (aValue < bValue) return order === 'asc' ? -1 : 1;
                if (aValue > bValue) return order === 'asc' ? 1 : -1;
                return 0;
            })
        );
    };
    
    return {
        extensionUnits,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        error,
        setError,
        sortField,
        sortOrder,
        setSortField,
        setSortOrder,
        handleSort
    };
}